export default "__VITE_ASSET__Dka7hR5Y__"